<div class="search-section" [class.disabled]="disableSearch">
  <app-svg-icon
    [iconName]="'search.svg'"
    [width]="'20'"
    [height]="'20'"
    class="search-icon"
  ></app-svg-icon>
  <input
    type="text"
    [placeholder]="placeholder"
    [ngModel]="searchQuery"
    (ngModelChange)="onModelChange($event)"
    [disabled]="disableSearch"
  />
  @if (searchQuery && !disableSearch) {
    <button
      class="clear-button"
      (click)="clearSearch()"
      type="button"
      aria-label="Clear search"
    >
      <app-svg-icon
        [iconName]="'close.svg'"
        [width]="'16'"
        [height]="'16'"
        class="clear-icon"
      ></app-svg-icon>
    </button>
  }
</div>
